import axios from '@src/utils/axios'

const module = 'hrflow'
const axiosInstance = axios(false);

export default {
  search: (ctx, data) => axiosInstance.get(`${module}/searching`, { params: data })
}